import React, { Component, Fragment } from 'react';
import tinyColor from 'tinycolor2';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Card, CardHeader,
  Row, Col, Container,
} from 'reactstrap';
import { bindActionCreators } from 'redux';
import * as snapSellWizardActions from 'actions/snapSellWizardActions';
import * as checkoutDataActions from 'actions/checkoutDataActions';
import * as publishersActions from 'actions/publishersActions';
import styles from './SnapSellPackagePage.scss';
import { clearAuthorizationToken } from 'lib/auth';
import { List } from 'immutable';
import CurrencySelect from 'components/snapsell/CurrencySelect';
import { currencySigns } from 'lib/support';
import PoweredByEvvnt from 'assets/images/powered_by_evvnt.png';
import PackageBlock from '../components/snapsell/PackageBlock';
import PaidFeaturesSummary from '../components/snapsell/PaidFeaturesSummary';
import FreeFeaturesSummary from '../components/snapsell/FreeFeaturesSummary';
import HowItWorks from '../components/snapsell/HowItWorks';
import FeaturesSection from '../components/snapsell/FeaturesSection';
import PricingTableSection from '../components/snapsell/PricingTableSection';
import TestimonialSection from '../components/snapsell/TestimonialSection';
import Faq from '../components/snapsell/Faq';
import { trackPageView, trackEvent} from '../lib/eventTracking';
import { nPublishersByVisitors } from 'lib/parsePublishers';

class SnapSellPackagePage extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    goToNextSnapSellStep: PropTypes.func.isRequired,
    changePackageType: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);

    this.setRef = this.setRef.bind(this);
  }

  setRef(input) {
    this.childRef = input;
  }

  state = {
    singleEventQuantity: 1,
    subscriptionEventQuantity: 4,
    monthlyDiscount: null
  }

  onSingleQuantityChange = (newQuantity) => {
    this.setState({ singleEventQuantity: newQuantity });
    this.props.getSnapsellSinglePrice(newQuantity);
  }

  onSubscriptionQuantityChange = (newQuantity) => {
    this.setState({ subscriptionEventQuantity: newQuantity });
    this.props.getSnapsellSubscriptionPrice(newQuantity);
  }

  setNavVisibility(elementId, visibilityStyle){
    const nav = document.getElementById(elementId);
    if (nav){
      nav.style.display = visibilityStyle;
    }
  }

  componentWillMount(){
    this.setNavVisibility('standard-nav','none');
    this.setNavVisibility('snapsell-nav', 'inline-flex');
  }

  componentWillUnmount(){
    this.setNavVisibility('snapsell-nav', 'none');
    this.setNavVisibility('standard-nav','inline-flex');
  }

  componentDidMount() {
    trackPageView('Snapsell');

    if (!this.props.singlePrice || !this.props.subscriptionPrice) this.props.getSnapSellPrices();
    if (this.props.availablePublishersCount < 1) this.props.fetchPublishers();

    window.onpopstate = (e) => this.props.goToPreviousSnapSellStep();
  }

  onFree = () => {
    this.props.changePackageType('free');
    trackEvent('Snapsell - Selected Package', { package_type: 'free' })
    this.props.history.push({ pathname: '/basics' });
  };

  onBuy = (packageType) => {
    this.props.changePackageType(packageType);
    this.props.changePackageEventQuantity(packageType === 'single' ? this.state.singleEventQuantity : this.state.subscriptionEventQuantity);
    trackEvent('Snapsell - Selected Package', { package_type: packageType });
    window.history.pushState({}, '', window.location.href);
    this.props.goToNextSnapSellStep();
  };

  onLogout = () => clearAuthorizationToken();

  onCurrencyChange = (newCurrency) => {
    this.props.changePackageCurrency(newCurrency);
    this.props.getSnapSellPrices(this.state.singleEventQuantity, this.state.subscriptionEventQuantity);
  }

  renderCurrency(themeBackgroundColor, themeLightestBgColor) {
    const {
      currency,
      availableCurrencies,
    } = this.props;
    return <CurrencySelect
      currentCurrency={currency}
      availableOptions={availableCurrencies}
      onChange={this.onCurrencyChange}
      themeBackgroundColor={themeBackgroundColor}
      themeLightestBgColor={themeLightestBgColor}
    />;
  }

  scrollAllPublishers(){
    window.scrollTo({ left: 0, top: this.inputNode.offsetTop, behavior: 'smooth'});
  }

  calculateMonthlyDiscount(){
    const { subscriptionPrice, singlePrice } = this.props;
    const monthPerEventPrice = subscriptionPrice / this.state.subscriptionEventQuantity;
    const singlePerEventPrice = singlePrice / this.state.singleEventQuantity;
    const monthlyDiscount = Math.round((singlePerEventPrice - monthPerEventPrice) / singlePerEventPrice * 100);
    this.setState({monthlyDiscount: monthlyDiscount});
  }

  requestDemoButton(style){
    return( <div className="request-demo">
      Not sure which plan is right for you? <br/>
      <span className="bolder">Schedule a call</span><br/>
      <a className="btn btn-themed" href={this.props.demoUrl} target="_blank"
        style={style}>
        Request a Demo
      </a>
    </div>
    );
  }

  render() {
    const {
      singlePrice,
      subscriptionPrice,
      loadingSinglePrice,
      loadingSubscriptionPrice,
      title,
      town,
      publishers,
      featuringPublisher,
      availableCurrencies,
      partnerExports,
      marketName,
      isValidForOriginPublisher,
      availablePublishersCount,
      currency,
      pricingTiers,
      subscriptionTiers,
      packageTemplateSet
    } = this.props;

    if ((!this.props.singlePrice || !this.props.subscriptionPrice) && (loadingSinglePrice || loadingSubscriptionPrice))
      return null;

    if (!this.state.monthlyDiscount){
      this.calculateMonthlyDiscount();
    }

    const themeBackgroundColor = this.props.theme.get('banner_bg_color');
    const themeTextColor = this.props.theme.get('banner_text_color');
    const btnBackgroundColor = this.props.theme.get('plugin_primary_button_color');
    const btnTextColor = this.props.theme.get('plugin_primary_button_text_color');
    const primaryButtonStyle = { color: btnTextColor, backgroundColor: btnBackgroundColor };
    const secondaryButtonStyle = { color: btnBackgroundColor, borderColor: btnBackgroundColor,
      borderWidth: '2px', backgroundColor: '#fff' };

    const themeLighterBgColor = tinyColor(themeBackgroundColor).setAlpha(0.6).toString();
    const themeLightestBgColor = tinyColor(themeBackgroundColor).setAlpha(0.1).toString();
    const themeDarkerBgColor = tinyColor(themeBackgroundColor).darken(8).toString();

    const publisherName = featuringPublisher ? featuringPublisher.get('name') : '';
    const features = (partnerExports && isValidForOriginPublisher) ? partnerExports.toJS() : {};
    const isFreePackageAvailable = packageTemplateSet.get('free_available');

    return (
      <div className={styles.snapSellPackagePage}>
        <Container>
          <Row>
            <div className="headline-bg" style={{backgroundColor: themeBackgroundColor}}/>
            <Col className="top-title text-center my-3">
              <div className="powered_by_evvnt">
                <img src={PoweredByEvvnt} />
              </div>
              <div className="headerText" style={{color: themeTextColor}}>
                  Choose a package and start promoting your event
                <div className="title">{title}
                  {town && <Fragment> in {town}
                  </Fragment>}
                  &nbsp;now
                </div>
              </div>
            </Col>
          </Row>
          { availableCurrencies.size > 1 && this.renderCurrency(themeBackgroundColor,themeLightestBgColor)}
          <Row className="pricing-row">
            <Col className={isFreePackageAvailable ? 'col-lg-12 col-xl-8' : 'col-lg-12'}>
              <Card className="premium">
                <CardHeader style={{backgroundColor: themeLightestBgColor, color: themeDarkerBgColor}}>
                  Premium {marketName}
                </CardHeader>
                <Row className="no-gutters">
                  <Col xs="12" lg="6">
                    <PackageBlock primaryColor={themeBackgroundColor} packageType="single" bestFor="occasional"
                      actionBtn={() => this.onBuy('single')}
                      primaryButtonStyle={primaryButtonStyle}
                      secondaryButtonStyle={secondaryButtonStyle}
                      price={singlePrice}
                      themeLightestBgColor={themeLightestBgColor}
                      currency={currencySigns[currency]}
                      isLoadingPrice={loadingSinglePrice}
                      discountValue={20}
                      discountDescr={<span>Discount<br/>Buy 3+ Credit</span>}
                      onInputQuantityChange={ () => this.onSingleQuantityChange}
                      eventQuantity={this.state.singleEventQuantity}/>
                  </Col>
                  <Col xs="12" lg="6">
                    <PackageBlock
                      primaryColor={themeBackgroundColor} packageType="subscription" bestFor="regular"
                      actionBtn={() => this.onBuy('subscription')}
                      primaryButtonStyle={primaryButtonStyle}
                      secondaryButtonStyle={secondaryButtonStyle}
                      price={subscriptionPrice}
                      themeLightestBgColor={themeLightestBgColor}
                      currency={currencySigns[currency]}
                      isLoadingPrice= {loadingSubscriptionPrice}
                      estimatedPrice={true}
                      discountValue={this.state.monthlyDiscount}
                      discountDescr={<span>Discount on our <br/> one off price</span>}
                      onInputQuantityChange={ () => this.onSubscriptionQuantityChange}
                      eventQuantity={this.state.subscriptionEventQuantity}/>
                  </Col>
                </Row>
                <PaidFeaturesSummary
                  featuringPublisher={featuringPublisher}
                  availablePublishersCount={availablePublishersCount}
                  partnerExports={partnerExports}
                  isValidForOriginPublisher={isValidForOriginPublisher}
                  topPublishers={nPublishersByVisitors(publishers, 15)}
                  scrollAllPublishers={() => this.scrollAllPublishers()}
                />
              </Card>
            </Col>
            { isFreePackageAvailable &&
              <Col lg="12" xl="4">
                <Card className="free">
                  <PackageBlock primaryColor={themeBackgroundColor} primaryButtonStyle={primaryButtonStyle}
                    secondaryButtonStyle={secondaryButtonStyle} lighterPrimaryColor={themeLighterBgColor} packageType="free" actionBtn={this.onFree}/>
                  <FreeFeaturesSummary featuringPublisher={featuringPublisher} publisherName={publisherName} features={features}/>
                </Card>
                { this.requestDemoButton(secondaryButtonStyle) }
              </Col>
            }
          </Row>
          { !isFreePackageAvailable && this.requestDemoButton(secondaryButtonStyle) }
          <HowItWorks/>
          <FeaturesSection
            inputRef={node => this.inputNode = node}
            features={features}
            featuringPublisher={featuringPublisher}
            availablePublishersCount={availablePublishersCount}
            publishers={publishers}
          />
          <PricingTableSection pricingTiers={pricingTiers} subscriptionTiers={subscriptionTiers} currency={currency}
            backgroundColor={themeBackgroundColor} textColor={themeTextColor} themeLightestBgColor={themeLightestBgColor}
          />
          <TestimonialSection/>
          <Faq/>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  currentUser: state.currentUser.get('data'),
  marketName: state.checkoutData.get('market_public_name'),
  singlePrice: state.checkoutData.get('singlePrice'),
  pricingTiers: state.pricingTiers,
  subscriptionTiers: state.subscriptionTiers,
  subscriptionPrice: state.checkoutData.get('subscriptionPrice'),
  loadingSinglePrice: state.checkoutData.get('isSinglePriceLoading'),
  loadingSubscriptionPrice: state.checkoutData.get('isSubscriptionPriceLoading'),
  partnerExports: state.checkoutData.get('partner_exports'),
  userLoggedIn: state.currentUser.get('isLoggedIn'),
  loginUrl: state.config.get('login_url'),
  logoutUrl: state.config.get('logout_url'),
  ssoGeotixUrl: state.config.get('sso_geotix_url'),
  categories: state.categories,
  categoryId: state.form.eventSubmission.values.category_id,
  town: state.form.eventSubmission.values.venue.town,
  title: state.form.eventSubmission.values.title,
  featuringPublisher: state.checkoutData.get('featuring_publisher'),
  isValidForOriginPublisher: state.checkoutData.get('valid_for_origin_publisher'),
  availablePublishersCount: state.publishers.get('totalCount'),
  publishers: state.publishers.get('data'),
  currency: state.checkoutData.get('currency'),
  theme: state.config.get('theme'),
  availableCurrencies: state.checkoutData.get('available_currencies'),
  packageTemplateSet: state.checkoutData.get('package_template_set'),
  demoUrl: state.config.get('demo_url'),
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  ...bindActionCreators(snapSellWizardActions, dispatch),
  ...bindActionCreators(checkoutDataActions, dispatch),
  ...bindActionCreators(publishersActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(SnapSellPackagePage);



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/containers/SnapSellPackagePage.jsx